module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAclBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9eWEHEAAAAJXRSTlMAAQMODxAUGh4qKzBNVldYXWB5qaqrsbKzt7i5usrr7O3y+P3+oyhdogAAAJlJREFUKM+dk0kSwjAMBMchYYewB7LgQNz//yJXAkgH+tpVKns0khS2TUyMSLEtgyRNbvykzqVgOGiCNpiUqgGI1emNKgLQ6g5wLTSiqAB6DUD/4aQ8AkkJuOqLC4AScP6Wx0+53mWmnA90S0uugOchsyV0C0fymP4pnbHmg2bJ+YrWezsEIz4zeHdl7rLdmrgFc6vplto7hxeWWkCqeApWDQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/video.png
// module id = Ea81
// module chunks = 215